import * as React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'

import { useCookies } from 'react-cookie'

import { fontCompress } from './globalStyles'

const Header: React.FC<{ siteTitle: string }> = ({ siteTitle }) => {
  const imageSrcs: {
    file: {
      publicURL: string;
    }
  } = useStaticQuery<{
    file: {
      publicURL: string;
    }
  }>(graphql`
    query {
      file(relativePath: {eq: "logo.svg"}) {
        publicURL
      }
    }
  `)
  const [cookie,setCookie,removeCookie] = useCookies(['totossawcollectionorder'])
  const logoSrc = imageSrcs.file.publicURL
  return (
    <MainHead>
      <div>
        <h1>
          <Link
            to="/"
          >
            <img src={logoSrc} alt={siteTitle} />
          </Link>
        </h1>
      </div>
      <OrderCount>
        <Link to={'/order/'}>{cookie.totossawcollectionorder?.length || 0}</Link>
      </OrderCount>
    </MainHead>
  )
}
  

export default Header

const MainHead = styled.header`
  position: sticky;
  top: 0;
  z-index: 1;
  height: 60px;
  padding: 14px;
  box-sizing: border-box;
  border-bottom: 1px solid #000;
  background: #fff;
  div{
    display: flex;
    justify-content: space-around;
    h1{
      img{
        height: 30px;
        margin: 0 4px 0 0;
      }
    }
  }
`

const OrderCount = styled.span`
  background: #040000;
  display: inline-block;
  position: absolute;
  box-sizing: border-box;
  right: 30px;
  top: 18px;
  height: 22px;
  padding: 3.5px 6.5px 3px;
  a{
    ${ fontCompress }
    color: #ffffff;
    display: inline-block;
    text-align: center;
    font-size: 15px;
  }
  @media screen and (max-width: 768px) {
    right: 24px;
  }
`